import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from 'view/common/with-async';
export const AiAnswerFeedbackPage = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "ai-answer-feedback-page" */ './hocs')),
});
